export type DiagKind = "console" | "network";
export type DiagEvent = { kind: DiagKind; detail: Record<string, unknown>; tOffsetMs: number };

// Single timeline-stamped capture layer (testability §E). One seam consumed by
// the /bt oracle AND any session-repro tool — do not build a parallel collector.
export function stampEvent(
  kind: DiagKind, detail: Record<string, unknown>, t0: number, now = Date.now(),
): DiagEvent {
  return { kind, detail, tOffsetMs: Math.max(0, now - t0) };
}

declare global {
  interface Window { __briolinDiag?: DiagEvent[]; __briolinT0?: number }
}

export function installDiagnostics(): void {
  if (typeof window === "undefined" || window.__briolinDiag) return;
  const t0 = Date.now();
  window.__briolinT0 = t0;
  const buf: DiagEvent[] = [];
  window.__briolinDiag = buf;

  for (const level of ["error", "warn"] as const) {
    const orig = console[level].bind(console);
    console[level] = (...args: unknown[]) => {
      buf.push(stampEvent("console", { level, text: args.map(String).join(" ") }, t0));
      orig(...args);
    };
  }

  const origFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === "string" ? input : input.toString();
    try {
      const res = await origFetch(input, init);
      buf.push(stampEvent("network", { url, status: res.status, ok: res.ok }, t0));
      return res;
    } catch (err) {
      buf.push(stampEvent("network", { url, status: 0, ok: false, error: String(err) }, t0));
      throw err;
    }
  };
}
